/**
 * Utility functions for managing anonymous users
 */

/**
 * Generates a random anonymous user name
 * @returns A string in the format "Anonymous_XXXX" where XXXX is a random 4-digit number
 */
export const generateAnonymousUserName = (): string => {
  const randomNumber = Math.floor(Math.random() * 9000) + 1000; // Generates 1000-9999
  return `Anonymous_${randomNumber}`;
};

/**
 * sets user email recieved from octa
 */
export const setUserNameFromOcta = (userName: string | undefined): string => {
  const USER_NAME_KEY = 'user_name';

  // Store it in localStorage
  localStorage.setItem(USER_NAME_KEY, userName || 'Anonymous');

  return userName || 'Anonymous';
};

/**
 * Gets the current user name from localStorage or creates a new anonymous user
 * @returns The user name (either existing or newly created)
 */
export const getOrCreateAnonymousUser = (): string => {
  const USER_NAME_KEY = 'user_name';

  // Check if user_name already exists in localStorage
  const existingUserName = localStorage.getItem(USER_NAME_KEY);

  if (existingUserName) {
    return existingUserName;
  }

  // Create a new anonymous user name
  const newUserName = generateAnonymousUserName();

  // Store it in localStorage
  localStorage.setItem(USER_NAME_KEY, newUserName);

  return newUserName;
};

/**
 * Clears the anonymous user from localStorage
 * This can be used for testing or if user wants to reset their anonymous identity
 */
export const clearAnonymousUser = (): void => {
  const USER_NAME_KEY = 'user_name';
  localStorage.removeItem(USER_NAME_KEY);
};
